import { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { getDocumentName } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { DocumentTemplatePage_OneDocumentTemplate_QueryDocument } from './useFindOneDocumentTemplateQuery.hook';

export const useQueryInvalidation = (documentTemplateId: Id) => {
  const queryClient = useQueryClient();

  const queryKeyToInvalidate = useMemo(
    () => [
      getDocumentName(DocumentTemplatePage_OneDocumentTemplate_QueryDocument),
      { id: documentTemplateId },
    ],
    [documentTemplateId],
  );

  const invalidateQueries = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: queryKeyToInvalidate,
    });
  }, [queryClient, queryKeyToInvalidate]);

  return {
    invalidateQueries,
    queryKeyToInvalidate,
  };
};
